

export function hasDbAccess(user)
{
    const now = Date.now();
    const dbu = user ? new Date(user.dbu * 1000) : new Date(0);
    return  dbu > now;
}
